import { render, staticRenderFns } from "./AddNewAgentCommissionInvoice.vue?vue&type=template&id=6cb555e3&scoped=true&"
import script from "./AddNewAgentCommissionInvoice.vue?vue&type=script&lang=js&"
export * from "./AddNewAgentCommissionInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAgentCommissionInvoice.vue?vue&type=style&index=0&id=6cb555e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb555e3",
  null
  
)

export default component.exports